export const BAYER_BASE_URL = process.env.VUE_APP_BAYER_BASE_URL
export const IDT_BASE_URL = process.env.VUE_APP_IDT_BASE_URL
// 是否是本地开发环境
export const IS_LOCAL = process.env.VUE_APP_MODE === 'local'
// 认证信息
export const AUTH_CONFIG = {
  // 认证方式: base userinfo 微信认证; wecom privateinfo 企业微信认证
  scope: 'wecom',
  // 返回值格式:
  // base64 将 json 字符串转换为 base64 编码的字符串;
  // encodeurl 将 json 字符串转换为 encodeurl 编码的字符串
  result_type: 'encodeurl',
}

// 本地调试用的认证信息
// export const AUTH_CWID = 'GNKDN'
// export const AUTH_CWID = 'EFXQZ'
export const AUTH_CWID = 'EFXQR'
// export const AUTH_CWID = 'GMNVJ'

// 用户职位
/** 代表 - 68 */
export const AUTH_MR = 68 
/** 经理 - 69 */
export const AUTH_DM = 69
/** 经理兼代表 - 70 */
export const AUTH_ADMIN = 70

// 企微认证接口
export const WX_AUTH_URL = [
  {
    wx: 'https://wecomapi-q.bayer.cn',
    idt: 'https://uat-bayer.imagedt.com',
    accessCode: 126,
  },
  {
    wx: 'https://wecomapi-q.bayer.cn',
    idt: 'https://uat-xdisplay.bayer.cn',
    accessCode: 126,
  },
  {
    wx: 'https://wecomapi.bayer.cn',
    idt: 'https://xdisplay.bayer.cn',
    accessCode: 124,
  },
  {
    wx: 'https://wecomapi.bayer.cn',
    idt: 'https://bayer.imagedt.com',
    accessCode: 124,
  },
]
